import type { Value } from 'platejs'
import type { TPlateEditor } from 'platejs/react'

export const isSelectionChangeOnly = <V extends Value>(
  editor: TPlateEditor<V>,
): boolean =>
  editor.operations.length > 0 &&
  editor.operations.every((operation) => operation.type === 'set_selection')
